
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("egHHW", function(module, exports) {

$parcel$export(module.exports, "Nav3SpaceNavigationContent", () => $74f7d4cbf6115d42$export$bc73fcb5b19302e5);
/* Nav3SpaceNavigationContent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $bH7mF = parcelRequire("bH7mF");
var $foAzt = parcelRequire("foAzt");

var $irVI7 = parcelRequire("irVI7");
var $1eaCJ = parcelRequire("1eaCJ");

var $i8GdI = parcelRequire("i8GdI");

var $4A6OA = parcelRequire("4A6OA");

var $jmjWc = parcelRequire("jmjWc");

var $dIouf = parcelRequire("dIouf");

var $7d2Nc = parcelRequire("7d2Nc");

var $1Sim2 = parcelRequire("1Sim2");

var $5s27v = parcelRequire("5s27v");

var $E9Pwd = parcelRequire("E9Pwd");

var $a0Wth = parcelRequire("a0Wth");

var $hTtye = parcelRequire("hTtye");

var $ENihE = parcelRequire("ENihE");

var $aWrnw = parcelRequire("aWrnw");

const $74f7d4cbf6115d42$var$ErrorView = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Mi2LS",
    name: "ErrorView",
    loader: async ()=>(await (parcelRequire("km9y4"))).ErrorView
});

const $74f7d4cbf6115d42$var$Nav3SpaceApps = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ZK5Ip",
    name: "Nav3SpaceApps",
    loader: async ()=>(await (parcelRequire("7DPsH"))).Nav3SpaceApps
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $74f7d4cbf6115d42$var$LegacySpaceLinksContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_18s8ze3t _1yt4ze3t _qtt8glyw _otyrf6fq _ca0qv77o _lcb2idpf",
            __cmplp.className
        ])
    });
});
const $74f7d4cbf6115d42$var$SidebarContent = /*#__PURE__*/ (0, $gwFzn.memo)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
/*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_n3td1ou6 _kqswh2mm _19pkze3t",
            __cmplp.className
        ])
    });
}));
const $74f7d4cbf6115d42$export$bc73fcb5b19302e5 = ({ navigationProps: navigationProps, errorProps: errorProps, name: name, iconPath: iconPath, containsExternalCollaborators: containsExternalCollaborators, isUserExternalCollaborator: isUserExternalCollaborator, isSpaceSettingsScreen: isSpaceSettingsScreen, isUserViewingSpaceAsAnon: isUserViewingSpaceAsAnon })=>{
    const { loading: loading, hasSpace: hasSpace, space: space, spaceKey: spaceKey, homepageId: homepageId, main: main, quick: quick, isSpaceAdmin: isSpaceAdmin, isBlogNavigation: isBlogNavigation, blogsHidden: blogsHidden, pageTreeFinishedLoading: pageTreeFinishedLoading, onDragDropSuccess: onDragDropSuccess, showShortcutsSection: showShortcutsSection, shouldRenderSpaceApps: shouldRenderSpaceApps, allAppLinks: allAppLinks, allVisibleAppLinks: allVisibleAppLinks, loadingForgeApps: loadingForgeApps, anonymousAccessQueryLoading: anonymousAccessQueryLoading, onContentTreeLoadComplete: onContentTreeLoadComplete } = navigationProps;
    const { unhandledError: unhandledError, hasRestrictedError: hasRestrictedError, hasNotFoundError: hasNotFoundError, anonymousAccessQueryError: anonymousAccessQueryError } = errorProps;
    const intl = (0, $dBxQj.default)();
    if (unhandledError || hasRestrictedError || hasNotFoundError || anonymousAccessQueryError || !loading && !hasSpace) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($74f7d4cbf6115d42$var$ErrorView, {
        unhandledError: unhandledError || anonymousAccessQueryError,
        hasRestrictedError: hasRestrictedError,
        hasNotFoundError: hasNotFoundError
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $foAzt.default), {
        label: intl.formatMessage($74f7d4cbf6115d42$var$i18n.navRegionLabel)
    }, loading || !name ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $a0Wth.SpaceHeaderSkeleton), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $E9Pwd.SpaceHeader), {
        spaceKey: spaceKey,
        spaceName: name,
        space: space,
        iconPath: iconPath,
        homepageId: homepageId,
        containsExternalCollaborators: containsExternalCollaborators,
        isUserExternalCollaborator: isUserExternalCollaborator
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bH7mF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($74f7d4cbf6115d42$var$SidebarContent, {
        "data-vc": "space-navigation-sidebar-content"
    }, !loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.APP_NAV_CONTAINER_EXPERIENCE)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($74f7d4cbf6115d42$var$LegacySpaceLinksContainer, {
        "data-testId": "legacy-space-links",
        "data-vc": "legacy-space-links"
    }, loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ENihE.ContainerSkeleton), {
        header: false
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hTtye.LegacySpaceLinks), {
        isSpaceAdmin: isSpaceAdmin,
        links: main,
        isSpaceSettingsScreen: isSpaceSettingsScreen
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5s27v.CommonSpaceNavigationContent), {
        showShortcutsSection: showShortcutsSection,
        space: space,
        spaceKey: spaceKey,
        quick: quick,
        homepageId: homepageId,
        loading: loading,
        isSpaceAdmin: isSpaceAdmin,
        isBlogNavigation: isBlogNavigation,
        blogsHidden: blogsHidden,
        pageTreeFinishedLoading: pageTreeFinishedLoading,
        onDragDropSuccess: onDragDropSuccess,
        onContentTreeLoadComplete: onContentTreeLoadComplete
    }), !loading && !loadingForgeApps && shouldRenderSpaceApps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).ECOSYSTEM
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7d2Nc.PageSegmentLoadStart), {
        metric: (0, $aWrnw.SPACE_APPS_METRIC)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($74f7d4cbf6115d42$var$Nav3SpaceApps, {
        spaceKey: spaceKey,
        isSpaceAdmin: isSpaceAdmin,
        allAppLinks: allAppLinks,
        allVisibleAppLinks: allVisibleAppLinks
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1Sim2.PostOfficeConfluenceSideNavPlacement), null), isUserViewingSpaceAsAnon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $i8GdI.AnonymousAccessSideNavMessage), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, !anonymousAccessQueryLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4A6OA.PersistentInvitePeopleButton), {
        source: "pageTree"
    })));
};
const $74f7d4cbf6115d42$var$i18n = (0, $2nPZH.defineMessages)({
    navRegionLabel: {
        id: "side-navigation.space-navigation.nav.region.aria.label",
        defaultMessage: "Space"
    }
});

});
parcelRegister("bH7mF", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d3965d48dffc154$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $kkFRk = parcelRequire("kkFRk");

var $h49AA = parcelRequire("h49AA");
const $3d3965d48dffc154$var$outerContainerCSS = null;
const $3d3965d48dffc154$var$innerContainerCSS = {
    basic: "_1reo1wug _18m91wug _1e0c1txw _vchhusvi _1bsb1osq _kqswh2mm _2lx21bp4 _14mjgqwt _1ywu1ule _1qdgyh40 _18poh2mm _1bqqcs5v _tua5idpf _1hfk1q2g _aetrb3bt _3mxo1wug",
    topScrollIndicator: "_rfx3gqwt _cfu11ule _kfgtyh40 _1cs8stnw _1g0vcs5v _1rus1q2g _1kt9b3bt _1enwidpf _z5wtidpf"
};
const $3d3965d48dffc154$var$containerCSS = {
    basic: "_kqswh2mm _12l2u2gc _ahbqu2gc _1pfhidpf _1p3h12x7 _1l6bpxbi _auo4rdoj _hp2110yn",
    marginBlockStart: "_1pfhv77o"
}; /**
    * __Navigation content__
    *
    * A navigation content is used as the container for navigation items.
    *
    * - [Examples](https://atlassian.design/components/side-navigation/examples#content)
    * - [Code](https://atlassian.design/components/side-navigation/code)
    */ 
const $3d3965d48dffc154$var$NavigationContent = /*#__PURE__*/ (0, $gwFzn.forwardRef)((props, ref)=>{
    const { showTopScrollIndicator: showTopScrollIndicator, children: children, testId: testId } = props;
    const { shouldRender: shouldRender } = (0, $h49AA.useShouldNestedElementRender)();
    const scrollbar = (0, $kkFRk.default)();
    if (!shouldRender) return children;
    const typedRef = ref;
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        ref: typedRef,
        "data-testid": testId,
        className: (0, $35pXk.default)([
            "_1reo15vq _18m915vq _1e0c1txw _4t3i1osq _kqswh2mm _rfx3gqwt _cfu11ule _kfgtyh40 _1cs8stnw _1g0vkb7n _1rus1p09 _1kt9b3bt _1enwftgi _z5wtu2gc _14mjgqwt _1ywu1ule _1qdgyh40 _18postnw _1bqqkb7n _tua5idpf _1hfk1p09 _aetrb3bt _1gufidpf _1czdftgi _g0nfu2gc"
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
            ref: scrollbar.ref,
            className: (0, $35pXk.default)([
                $3d3965d48dffc154$var$innerContainerCSS.basic,
                !showTopScrollIndicator && $3d3965d48dffc154$var$innerContainerCSS.topScrollIndicator
            ]),
            children: /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                className: (0, $35pXk.default)([
                    $3d3965d48dffc154$var$containerCSS.basic,
                    showTopScrollIndicator && $3d3965d48dffc154$var$containerCSS.marginBlockStart
                ]),
                children: children
            })
        })
    });
});
var $3d3965d48dffc154$export$2e2bcd8739ae039 = $3d3965d48dffc154$var$NavigationContent;

});
parcelRegister("kkFRk", function(module, exports) {

$parcel$export(module.exports, "default", () => $92fe886a4ea58ae5$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");
function $92fe886a4ea58ae5$export$2e2bcd8739ae039() {
    const [scrollbarWidth, setScrollbarWidth] = (0, $gwFzn.useState)(0);
    const elementRef = (0, $gwFzn.useRef)(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $gwFzn.useEffect)(()=>{
        if (!elementRef.current) return;
        const width = elementRef.current.offsetWidth - elementRef.current.scrollWidth;
        if (width === scrollbarWidth) return;
        setScrollbarWidth(width);
    });
    return {
        width: scrollbarWidth,
        ref: elementRef
    };
}

});


parcelRegister("E9Pwd", function(module, exports) {

$parcel$export(module.exports, "SpaceHeader", () => $e766195d333104fc$export$533fb76256978163);
/* Nav3SpaceHeader.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $3gadb = parcelRequire("3gadb");

var $inPa6 = parcelRequire("inPa6");

var $9czQp = parcelRequire("9czQp");
var $kgOjN = parcelRequire("kgOjN");

var $5izcQ = parcelRequire("5izcQ");

var $1Zr9M = parcelRequire("1Zr9M");

var $jZM59 = parcelRequire("jZM59");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $2W0qg = parcelRequire("2W0qg");

var $dPJCf = parcelRequire("dPJCf");

var $irVI7 = parcelRequire("irVI7");
var $1kHsc = parcelRequire("1kHsc");

var $1NBp8 = parcelRequire("1NBp8");

var $7aRa9 = parcelRequire("7aRa9");

var $eWwvy = parcelRequire("eWwvy");

var $1ytiN = parcelRequire("1ytiN");

var $kK764 = parcelRequire("kK764");

var $6lvbX = parcelRequire("6lvbX");

var $joCMa = parcelRequire("joCMa");

var $jmjWc = parcelRequire("jmjWc");

var $kr1Wj = parcelRequire("kr1Wj");

const $e766195d333104fc$var$SpaceHeaderExCoOnboarding = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "eOVw9",
    name: "SpaceHeaderExCoOnboarding",
    loader: async ()=>(await (parcelRequire("alD5l"))).SpaceHeaderExCoOnboarding
});
const $e766195d333104fc$var$ANALYTICS_SOURCE = 'spaceHeader';
const $e766195d333104fc$var$ENTER_KEY_CODE = 13; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e766195d333104fc$var$SpaceIcon = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_2rko14y2 _1bsb1tcg _4t3i1tcg",
            __cmplp.className
        ])
    });
});
const $e766195d333104fc$var$editIconWrapper = (0, $ecnYn.xcss)({
    position: 'absolute',
    height: '24px',
    width: '24px',
    top: 'space.0',
    left: 'space.0',
    padding: 'space.050',
    opacity: 0,
    transition: 'opacity 0.5s ease',
    ':hover': {
        opacity: 1
    },
    ':focus': {
        opacity: 1
    },
    backgroundColor: 'color.blanket',
    borderRadius: '6px'
});
const $e766195d333104fc$var$spaceIconContainer = (0, $ecnYn.xcss)({
    position: 'relative',
    width: '100%',
    cursor: 'pointer',
    padding: 'space.0',
    border: 'none',
    background: 'none'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e766195d333104fc$var$HeaderContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_19pkzeo2 _kqswh2mm _4t3i8vuz",
            __cmplp.className
        ])
    });
});
const $e766195d333104fc$var$isOnSpaceRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.SPACE_INDEX).name || routeName === (0, $1NBp8.SPACE_OVERVIEW).name
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e766195d333104fc$var$SpaceHeaderOverviewShortcut = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_2rko1l7b _1e0c1ule _4t3i1osq _1bsb1osq _kqswstnw _154iidpf _1ltvidpf _nkqr166n _41l1166n _1n8gtlke _gjixtlke _wcbokb7n _1wp1kb7n _1oi81osq _49641osq _1d42u2gc _uuphu2gc _1umyu2gc _ghi6tlke _1i81kb7n _9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.isSelected ? "_bfhkfg4m" : "_bfhk18uv",
            __cmplp.isSelected ? "_12x0i1yw" : "_12x0166n",
            __cmplp.isSelected ? "_15alaqb7 _4w4yaqb7 _1jocaqb7" : "_15al1fxt _4w4y1fxt _1joc1fxt",
            __cmplp.className
        ])
    });
});
const $e766195d333104fc$var$OpenToTextContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_k48p1wq8",
            __cmplp.className
        ])
    });
});
const $e766195d333104fc$var$i18n = (0, $2nPZH.defineMessages)({
    editSpaceDetailsTooltip: {
        id: "side-navigation.space-navigation.header.space-avatar-edit-header-tooltip",
        defaultMessage: "Edit space details"
    },
    editSpaceDetailsError: {
        id: "side-navigation.space-navigation.header.space-avatar-error",
        defaultMessage: "Something went wrong. Please try again."
    },
    spacesOverviewShortcutTooltip: {
        id: "side-navigation.space-overview-shortcut.tooltip",
        defaultMessage: "View space overview"
    }
});
const $e766195d333104fc$var$SpaceAvatarHeader = ({ spaceName: spaceName, spaceDescription: spaceDescription, spaceOverviewUrl: spaceOverviewUrl, iconPath: iconPath, isSelected: isSelected, sendOverviewShortcutAnalytics: sendOverviewShortcutAnalytics = ()=>{} })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($e766195d333104fc$var$HeaderContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        position: "top",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $e766195d333104fc$var$i18n.spacesOverviewShortcutTooltip)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5izcQ.default), {
            name: "spaceheader"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($e766195d333104fc$var$SpaceHeaderOverviewShortcut, {
            href: spaceOverviewUrl,
            isSelected: isSelected,
            "aria-current": isSelected ? 'page' : undefined,
            ...tooltipProps,
            "data-testid": "space-header-overview-shortcut",
            "data-vc": "space-header-overview-shortcut",
            onClick: sendOverviewShortcutAnalytics
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9czQp.default), {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($e766195d333104fc$var$SpaceIcon, {
                src: iconPath || '',
                "data-testid": "space-icon",
                alt: "",
                "data-vc": "space-header-icon-image",
                "data-ssr-placeholder-ignored": true,
                role: "presentation"
            }),
            description: spaceDescription,
            testId: "space-header",
            "data-vc": "space-icon"
        }, spaceName)))));
};
const $e766195d333104fc$var$SpaceAvatarEditHeader = ({ space: space, isOpen: isOpen, onOpen: onOpen, onClose: onClose, flags: flags, intl: intl, iconPath: iconPath, leftSidebarState: leftSidebarState, expandLeftSidebar: expandLeftSidebar, spaceName: spaceName, spaceKey: spaceKey, spaceDescription: spaceDescription, spaceOverviewUrl: spaceOverviewUrl, isSelected: isSelected, sendOverviewShortcutAnalytics: sendOverviewShortcutAnalytics = ()=>{}, sendEditSpaceDetailsClickedAnalyticsEvent: sendEditSpaceDetailsClickedAnalyticsEvent = ()=>{} })=>{
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [shouldRenderEditSpaceLogoDialog, setShouldRenderEditSpaceLogoDialog] = (0, $gwFzn.useState)(false);
    const renderEditSpaceLogoDialog = (0, $gwFzn.useCallback)(()=>{
        setShouldRenderEditSpaceLogoDialog(true);
    }, []);
    const HandleSpaceIconClick = (0, $gwFzn.useCallback)((e)=>{
        e.stopPropagation();
        e.preventDefault();
        experienceTracker.start({
            name: (0, $irVI7.EDIT_SPACE_LOGO_DETAILS_LOAD_EXPERIENCE),
            // should not take more than 10s for the Edit Space Component Modal to appear
            timeout: 10000
        });
        if (leftSidebarState.isFlyoutOpen) expandLeftSidebar();
        sendEditSpaceDetailsClickedAnalyticsEvent();
        (0, $joCMa.getLegacyMessageQueue)().then((legacyMessageQueue)=>{
            legacyMessageQueue.push({
                type: 'ATLASSIAN_CONFLUENCE_EDIT_SPACE_LOGO',
                payload: {}
            });
        }).catch((error)=>{
            flags.showErrorFlag({
                id: 'edit-space-logo.actions.save.success',
                title: intl.formatMessage($e766195d333104fc$var$i18n.editSpaceDetailsError)
            });
            experienceTracker.stopOnError({
                name: (0, $irVI7.EDIT_SPACE_LOGO_DETAILS_LOAD_EXPERIENCE),
                error: error
            });
        });
    }, [
        flags,
        intl,
        experienceTracker,
        leftSidebarState.isFlyoutOpen,
        expandLeftSidebar,
        sendEditSpaceDetailsClickedAnalyticsEvent
    ]);
    const handleSpaceIconKeyDown = (0, $gwFzn.useCallback)((e)=>{
        if (e.keyCode == $e766195d333104fc$var$ENTER_KEY_CODE) HandleSpaceIconClick(e);
    }, [
        HandleSpaceIconClick
    ]);
    if (!space) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($e766195d333104fc$var$SpaceAvatarHeader, {
        iconPath: iconPath,
        spaceDescription: spaceDescription,
        spaceName: spaceName,
        spaceOverviewUrl: spaceOverviewUrl,
        isSelected: isSelected,
        sendOverviewShortcutAnalytics: sendOverviewShortcutAnalytics
    });
    const { type: type, operations: operations = [] } = space;
    const isSpaceAdmin = !!operations.filter((op)=>op.targetType === 'space' && op.operation === 'administer').length || false;
    const isPersonalSpace = type === 'personal';
    if (!isSpaceAdmin || isPersonalSpace) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($e766195d333104fc$var$SpaceAvatarHeader, {
        iconPath: iconPath,
        spaceDescription: spaceDescription,
        spaceName: spaceName,
        spaceOverviewUrl: spaceOverviewUrl,
        isSelected: isSelected,
        sendOverviewShortcutAnalytics: sendOverviewShortcutAnalytics
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($e766195d333104fc$var$HeaderContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        position: "top",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $e766195d333104fc$var$i18n.spacesOverviewShortcutTooltip)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($e766195d333104fc$var$SpaceHeaderOverviewShortcut, {
            href: spaceOverviewUrl,
            isSelected: isSelected,
            ...tooltipProps,
            "data-testid": "space-header-overview-shortcut",
            onClick: sendOverviewShortcutAnalytics,
            "data-vc": "space-header-overview-shortcut"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9czQp.default), {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $e766195d333104fc$var$i18n.editSpaceDetailsTooltip)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2W0qg.default), {
                xcss: $e766195d333104fc$var$spaceIconContainer,
                onClick: HandleSpaceIconClick,
                onKeyDown: handleSpaceIconKeyDown,
                onFocus: renderEditSpaceLogoDialog,
                onMouseEnter: renderEditSpaceLogoDialog,
                "aria-label": intl.formatMessage($e766195d333104fc$var$i18n.editSpaceDetailsTooltip),
                testId: "space-icon-container"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($e766195d333104fc$var$SpaceIcon, {
                src: iconPath || '',
                "data-testid": "space-icon",
                "data-vc": "space-header-icon-image",
                "data-ssr-placeholder-ignored": true,
                role: "presentation"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
                xcss: $e766195d333104fc$var$editIconWrapper
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
                label: "",
                color: "var(--ds-icon-inverse, #FFFFFF)"
            })))),
            description: spaceDescription,
            testId: "space-header"
        }, spaceName))), shouldRenderEditSpaceLogoDialog && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eWwvy.EditSpaceLogo), {
        spaceKey: spaceKey,
        isOpen: isOpen,
        onOpen: onOpen,
        onClose: onClose
    }));
};
const $e766195d333104fc$var$SpaceHeaderComponent = ({ spaceKey: spaceKey, spaceName: spaceName, space: space, iconPath: iconPath, homepageId: homepageId, containsExternalCollaborators: containsExternalCollaborators, isUserExternalCollaborator: isUserExternalCollaborator, flags: flags })=>{
    const intl = (0, $dBxQj.default)(); // Changeboarding for how to find a space's list of external collaborators by invoking a link from the space header:
    // Step 1: show an onboarding modal to display a space's list of external collaborators
    // Step 2: dismissing the modal stops the modal from being shown again in the future (shows only once per user per Confluence site)
    // Step 3: show a nonintrusive nudge "pulse" around the space header (when conditions are right)
    // Step 4: when user hovers over the pulse, show the full spotlight complete with overlay and message
    // Step 5: clicking on the spotlight action dismisses the entire changeboarding
    // This will only work if messages are shown in the same session. We'll need to find another implmentation if user has seen message #1 (modal) already, but not message #2 (pulse)
    const [showExCoOnboardingNudge, setShowExCoOnboardingNudge] = (0, $gwFzn.useState)(false);
    const [onboardingStep, setOnboardingStep] = (0, $gwFzn.useState)(0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isEditSpaceModalOpen, setIsEditSpaceModalOpen] = (0, $gwFzn.useState)(false);
    const onEditSpaceModalOpen = (0, $gwFzn.useCallback)(()=>setIsEditSpaceModalOpen(true), []);
    const onEditSpaceModalClose = (0, $gwFzn.useCallback)(()=>setIsEditSpaceModalOpen(false), []);
    const { isLeftSidebarCollapsed: isLeftSidebarCollapsed, leftSidebarState: leftSidebarState, expandLeftSidebar: expandLeftSidebar } = (0, $jZM59.usePageLayoutResize)();
    const { isNewUser: isNewUser } = (0, $gwFzn.useContext)((0, $1ytiN.SPAViewContext)); // isSelected is used to highlight space header when on space overview
    const isSelected = (0, $dPJCf.useRouteName)($e766195d333104fc$var$isOnSpaceRouteArgs);
    const spaceOverviewUrl = (0, $1NBp8.SPACE_OVERVIEW).toUrl({
        spaceKey: spaceKey
    }, {
        query: homepageId ? {
            [(0, $1NBp8.SPACE_OVERVIEW).HOMEPAGE_ID_QUERY_KEY]: homepageId
        } : undefined
    });
    const showExCoMessaging = !isUserExternalCollaborator && containsExternalCollaborators;
    const sendEditSpaceDetailsClickedAnalyticsEvent = (0, $gwFzn.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'editSpaceDetails',
                source: 'sideNavSpaceHeader',
                attributes: {
                    navVersion: 3
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const sendOverviewShortcutAnalytics = (0, $gwFzn.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'spaceHeader',
                source: 'sideNavigation',
                attributes: {
                    navVersion: 3
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const getSpaceDescription = ()=>{
        // ExCo spaceDescription takes precedence over the personal space one
        if (showExCoMessaging) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($e766195d333104fc$var$OpenToTextContainer, {
            "data-testid": "space-exco-list-description-link"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6lvbX.ExternalCollaboratorsSpaceInformationMessage), {
            analyticsSource: $e766195d333104fc$var$ANALYTICS_SOURCE,
            messageType: (0, $6lvbX.ExternalCollaboratorsSpaceInformationMessageType).IN_SPACE,
            shouldShowMessageIcon: false,
            shouldShowAdditionalMessageContext: false,
            spaceKey: spaceKey,
            isSubtle: true
        }));
        else return undefined;
    };
    const header = space ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($e766195d333104fc$var$SpaceAvatarEditHeader, {
        isOpen: isEditSpaceModalOpen,
        onOpen: onEditSpaceModalOpen,
        onClose: onEditSpaceModalClose,
        leftSidebarState: leftSidebarState,
        expandLeftSidebar: expandLeftSidebar,
        intl: intl,
        flags: flags,
        iconPath: iconPath,
        spaceDescription: getSpaceDescription(),
        space: space,
        spaceName: spaceName,
        spaceKey: spaceKey,
        spaceOverviewUrl: spaceOverviewUrl,
        isSelected: isSelected,
        sendOverviewShortcutAnalytics: sendOverviewShortcutAnalytics,
        sendEditSpaceDetailsClickedAnalyticsEvent: sendEditSpaceDetailsClickedAnalyticsEvent
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($e766195d333104fc$var$SpaceAvatarHeader, {
        iconPath: iconPath,
        spaceDescription: getSpaceDescription(),
        spaceName: spaceName,
        spaceOverviewUrl: spaceOverviewUrl,
        isSelected: isSelected,
        sendOverviewShortcutAnalytics: sendOverviewShortcutAnalytics
    }); // Suppress exco onboarding if the user is new, since they will be bombarded with other unrelated onboarding
    // messages which we don't want to overlap with this one. (See: CONFDEV-75463) We are seeking a more permanent
    // solution to onboarding overlapping with EP changeboarding messages, but for now adding the !isNewUser check
    // will prevent that behavior.
    const showExCoModalOnboarding = !isNewUser && showExCoMessaging;
    const showExCoSpotlightOnboarding = !isNewUser && showExCoMessaging && showExCoOnboardingNudge && !isLeftSidebarCollapsed;
    const onGuestListOnboardingModalShown = ()=>{
        setShowExCoOnboardingNudge(true);
        setOnboardingStep(1);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kgOjN.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kr1Wj.GuestOnboardingModalLoadable), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, showExCoModalOnboarding && onboardingStep === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kK764.ExternalCollaboratorInSpaceNotify), {
        onModalClose: onGuestListOnboardingModalShown,
        spaceKey: spaceKey
    })), showExCoSpotlightOnboarding && onboardingStep === 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($e766195d333104fc$var$SpaceHeaderExCoOnboarding, {
        header: header,
        onClose: ()=>setShowExCoOnboardingNudge(false)
    }) : header);
};
const $e766195d333104fc$export$533fb76256978163 = (0, $7aRa9.withFlags)($e766195d333104fc$var$SpaceHeaderComponent);

});
parcelRegister("9czQp", function(module, exports) {

$parcel$export(module.exports, "default", () => $49e838c3ba22b338$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $7FIhm = parcelRequire("7FIhm");
const $49e838c3ba22b338$var$styles = {
    header: "_uizt1wug _vrjt140y _1cmd1fxt _11kj1w7a _jl2n73ad _1et61w7a _1v6j1fxt"
}; /**
    * __Container__
    *
    * A container for Header and Footer that safely handles props to the child component
    */ 
const $49e838c3ba22b338$export$42a852a2b6b56249 = ({ children: children, 'data-testid': testId, ...props })=>{
    // https://stackoverflow.com/a/39333479
    const safeProps = (({ className: className, onClick: onClick, onMouseDown: onMouseDown, onDragStart: onDragStart, draggable: draggable, ref: ref, tabIndex: tabIndex, disabled: disabled })=>({
            className: className,
            onClick: onClick,
            onMouseDown: onMouseDown,
            onDragStart: onDragStart,
            draggable: draggable,
            ref: ref,
            tabIndex: tabIndex,
            disabled: disabled
        }))(props);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        "data-testid": testId,
        style: {
            position: 'relative'
        },
        ...safeProps,
        children: children
    }));
};
/**
 * __Header__
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#header-and-footer)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $49e838c3ba22b338$var$Header = /*#__PURE__*/ (0, $gwFzn.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7FIhm.default), {
        ...props,
        ref: ref,
        component: props.component || $49e838c3ba22b338$export$42a852a2b6b56249,
        isTitleHeading: true,
        className: (0, $35pXk.default)([
            $49e838c3ba22b338$var$styles.header
        ])
    });
});
var $49e838c3ba22b338$export$2e2bcd8739ae039 = $49e838c3ba22b338$var$Header;

});

parcelRegister("kgOjN", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5f9234325359019$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $gdv5Z = parcelRequire("gdv5Z");
const $c5f9234325359019$var$styles = {
    navigationFooter: "_1e0c1ule _85i5u2gc _1q511ejb _y4tiu2gc _bozgu2gc"
};
/**
 * __Navigation header__
 *
 * Allows for customisation of the header.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#header-and-footer)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $c5f9234325359019$var$NavigationHeader = (props)=>{
    const { children: children } = props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        xcss: $c5f9234325359019$var$styles.navigationFooter,
        "data-navheader": true,
        children: children
    });
};
var $c5f9234325359019$export$2e2bcd8739ae039 = $c5f9234325359019$var$NavigationHeader;

});

parcelRegister("alD5l", function(module, exports) {

let $788a2f07b655d27c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $788a2f07b655d27c$var$load("1vHyq"),
    $788a2f07b655d27c$var$load("860dT")
]).then(()=>parcelRequire('8KFPL'));

});


parcelRegister("hTtye", function(module, exports) {

$parcel$export(module.exports, "LegacySpaceLinks", () => $80aadc0fc178ee11$export$14d624b4cb7e24cc);
/* LegacySpaceLinks.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $diswb = parcelRequire("diswb");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $inPa6 = parcelRequire("inPa6");

var $80xJE = parcelRequire("80xJE");

var $3gadb = parcelRequire("3gadb");

var $euL71 = parcelRequire("euL71");

var $dIouf = parcelRequire("dIouf");

var $9wGTI = parcelRequire("9wGTI");

var $1NBp8 = parcelRequire("1NBp8");

var $dPJCf = parcelRequire("dPJCf");

var $ep3mz = parcelRequire("ep3mz");

var $feuG2 = parcelRequire("feuG2");

var $bQm3c = parcelRequire("bQm3c");

var $jmjWc = parcelRequire("jmjWc");

var $8q3aB = parcelRequire("8q3aB");

var $7Ul0y = parcelRequire("7Ul0y");

var $coxGi = parcelRequire("coxGi");

var $ggcSj = parcelRequire("ggcSj");

var $28oQf = parcelRequire("28oQf");

var $27b4e = parcelRequire("27b4e");

var $lX4Fn = parcelRequire("lX4Fn");

const $80aadc0fc178ee11$var$GridIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AtHgo",
    name: "GridIcon",
    loader: async ()=>(await (parcelRequire("kfZiO"))).GridIcon
});

const $80aadc0fc178ee11$var$AutomationNavigation = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "jZ9T1",
    name: "AutomationNavigation",
    loader: async ()=>(await (parcelRequire("77ckH"))).AutomationNavigation
});

const $80aadc0fc178ee11$var$QuestionsNavigation = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "TyV6N",
    name: "QuestionsNavigation",
    loader: async ()=>(await (parcelRequire("5IITM"))).QuestionsNavigation
});

const $80aadc0fc178ee11$var$TeamCalendarNavigation = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "pe-GW",
    name: "TeamCalendarNavigation",
    loader: async ()=>(await (parcelRequire("dcxJa"))).TeamCalendarNavigation
});

const $80aadc0fc178ee11$var$BulkToolsNavigation = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "wgPHH",
    name: "BulkToolsNavigation",
    loader: async ()=>(await (parcelRequire("4STYZ"))).BulkToolsNavigation
});
const $80aadc0fc178ee11$var$i18nTooltips = (0, $2nPZH.defineMessages)({
    allContentTooltip: {
        id: "side-navigation.space-navigation.all-content.tooltip",
        defaultMessage: "View all content in this space"
    }
});
const $80aadc0fc178ee11$var$styles = {
    root: "_2rko1l7b _4bfu1r81 _1hmsagmp _ajmmvv82 _1rjcze3t _bozgu2gc _y4ti1b66 _4t3i14no _1tke14no _1wybdlk8 _bfhk18uv _6ehmu2gc _syaz1gjq _9h8h1gjq _f8pj1gjq _10531gjq _tx28idpf _f1531tcg _o2hc1tcg _vd4fgktf _10wwgktf _1l9sgktf _13lwgktf _g512gktf _1iyggktf _irr3166n",
    isSelected: "_bfhkfg4m _syazaqb7 _9h8haqb7 _f8pjaqb7 _1053aqb7 _irr3i1yw"
};
const $80aadc0fc178ee11$export$76be974a4f0c1975 = (pathname, route)=>Boolean(route.match(pathname || ''));
const $80aadc0fc178ee11$var$isOnDatabasesRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.DATABASE_CUSTOM_OVERVIEW).name
};
const $80aadc0fc178ee11$var$isOnSpacePagesRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.SPACE_PAGES).name
};
const $80aadc0fc178ee11$var$isOnAutomationRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.SPACE_SETTINGS_AUTOMATION).name
};
const $80aadc0fc178ee11$var$isOnSpaceCalendarsRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.SPACE_CALENDARS).name || routeName === (0, $1NBp8.SPACE_CALENDARS_SUBCALENDAR).name
};
const $80aadc0fc178ee11$var$isOnSpaceQuestionsRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.SPACE_QUESTIONS).name
};
const $80aadc0fc178ee11$var$isOnSpaceQuestionsNativeRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.SPACE_QUESTIONS_NATIVE).name
};
const $80aadc0fc178ee11$export$14d624b4cb7e24cc = /*#__PURE__*/ (0, $gwFzn.memo)(({ isSpaceAdmin: isSpaceAdmin, links: links, isSpaceSettingsScreen: isSpaceSettingsScreen = false })=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isLicensed: isLicensed, edition: edition } = (0, $bQm3c.useSessionData)();
    const isPremiumEdition = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const databasesRoute = (0, $1NBp8.DATABASE_CUSTOM_OVERVIEW);
    const [addSpaceLink] = (0, $diswb.useMutation)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Experimental Schema GraphQL Operation
    (0, $7Ul0y.AddSpaceLink), {
        refetchQueries: [
            {
                query: (0, $8q3aB.SpaceNavigationQuery),
                variables: {
                    spaceKey: spaceKey,
                    isLicensed: isLicensed
                }
            }
        ]
    });
    const [removeSpaceLink] = (0, $diswb.useMutation)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Experimental Schema GraphQL Operation
    (0, $coxGi.RemoveSpaceLink), {
        refetchQueries: [
            {
                query: (0, $8q3aB.SpaceNavigationQuery),
                variables: {
                    spaceKey: spaceKey,
                    isLicensed: isLicensed
                }
            }
        ]
    });
    (0, $ggcSj.useSidebarConfigurationListener)(addSpaceLink, removeSpaceLink);
    const sendItemClickedAnalytics = (0, $gwFzn.useCallback)((itemId, navdexPointType, additionalAttributes = {})=>()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'navigationItem',
                    actionSubjectId: 'spaceNavigationItem',
                    source: 'containerNavigation',
                    attributes: {
                        navigationLayer: 'container',
                        itemId: itemId,
                        selectedItemPageContext: routeDataRef.current?.routeName,
                        navVersion: '3',
                        navdexPointType: navdexPointType,
                        ...additionalAttributes
                    }
                }
            }).fire();
        }, [
        createAnalyticsEvent,
        routeDataRef
    ]);
    const isOnSpacePagesRoute = (0, $dPJCf.useRouteName)($80aadc0fc178ee11$var$isOnSpacePagesRouteArgs);
    const isOnAutomationRoute = (0, $dPJCf.useRouteName)($80aadc0fc178ee11$var$isOnAutomationRouteArgs);
    const isOnDatabasesRoute = (0, $dPJCf.useRouteName)($80aadc0fc178ee11$var$isOnDatabasesRouteArgs);
    const isOnSpaceCalendarsRoute = (0, $dPJCf.useRouteName)($80aadc0fc178ee11$var$isOnSpaceCalendarsRouteArgs);
    const isOnSpaceQuestionsRoute = (0, $dPJCf.useRouteName)($80aadc0fc178ee11$var$isOnSpaceQuestionsRouteArgs);
    const isOnSpaceQuestionsNativeRoute = (0, $dPJCf.useRouteName)($80aadc0fc178ee11$var$isOnSpaceQuestionsNativeRouteArgs);
    const getBuiltInItemsMapping = (0, $gwFzn.useCallback)(()=>({
            [(0, $28oQf.ANALYTICS_KEY)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lX4Fn.AnalyticsNavigation), {
                onClick: sendItemClickedAnalytics('analytics', undefined)
            }),
            [(0, $28oQf.ANALYTICS_KEY_MODERATE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lX4Fn.AnalyticsNavigation), {
                onClick: sendItemClickedAnalytics('analytics', undefined)
            }),
            [(0, $28oQf.QUESTIONS_KEY)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($80aadc0fc178ee11$var$QuestionsNavigation, {
                key: (0, $28oQf.QUESTIONS_KEY),
                isSelected: isOnSpaceQuestionsRoute,
                onClick: sendItemClickedAnalytics('questions', undefined),
                href: (0, $1NBp8.SPACE_QUESTIONS).toUrl({
                    spaceKey: spaceKey
                })
            }),
            ...(0, $9wGTI.fg)('cc_editions_cq_native') && {
                [(0, $28oQf.QUESTIONS_NATIVE_KEY)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($80aadc0fc178ee11$var$QuestionsNavigation, {
                    key: (0, $28oQf.QUESTIONS_NATIVE_KEY),
                    isSelected: isOnSpaceQuestionsNativeRoute,
                    onClick: sendItemClickedAnalytics('questions', undefined),
                    href: (0, $1NBp8.SPACE_QUESTIONS_NATIVE).toUrl({
                        spaceKey: spaceKey
                    })
                })
            },
            ...isSpaceAdmin && {
                [(0, $28oQf.AUTOMATION_KEY)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($80aadc0fc178ee11$var$AutomationNavigation, {
                    key: (0, $28oQf.AUTOMATION_KEY),
                    isSelected: isOnAutomationRoute,
                    onClick: sendItemClickedAnalytics('automation', undefined, {
                        edition: edition
                    }),
                    isSpaceAdmin: isSpaceAdmin
                })
            },
            [(0, $28oQf.CALENDARS_KEY)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($80aadc0fc178ee11$var$TeamCalendarNavigation, {
                key: (0, $28oQf.CALENDARS_KEY),
                isSelected: isOnSpaceCalendarsRoute,
                onClick: sendItemClickedAnalytics('calendars', undefined, {
                    isPremiumEdition: isPremiumEdition
                })
            }),
            [(0, $28oQf.DATABASES_KEY)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $27b4e.DatabasesNavigation), {
                key: (0, $28oQf.DATABASES_KEY),
                isSelected: isOnDatabasesRoute,
                onClick: sendItemClickedAnalytics('databases', undefined),
                databasesRoute: databasesRoute
            }),
            ...isPremiumEdition && isSpaceAdmin && {
                [(0, $28oQf.BULK_TOOLS_KEY)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($80aadc0fc178ee11$var$BulkToolsNavigation, {
                    key: (0, $28oQf.BULK_TOOLS_KEY),
                    testId: "bulk-tools-link",
                    onClick: sendItemClickedAnalytics('bulkTools', undefined)
                })
            }
        }), [
        sendItemClickedAnalytics,
        isOnSpaceQuestionsRoute,
        isPremiumEdition,
        isOnSpaceQuestionsNativeRoute,
        spaceKey,
        isSpaceAdmin,
        isOnAutomationRoute,
        edition,
        isOnSpaceCalendarsRoute,
        isOnDatabasesRoute,
        databasesRoute
    ]);
    const renderLegacySpaceLinks = (0, $gwFzn.useCallback)(()=>{
        const builtInItems = getBuiltInItemsMapping();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
            position: "top",
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $80aadc0fc178ee11$var$i18nTooltips.allContentTooltip)
        }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("li", {
                "data-vc": "space-link"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $80xJE.default), {
                key: "all-content",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($80aadc0fc178ee11$var$GridIcon, {
                    isSelected: isOnSpacePagesRoute
                }),
                isSelected: isOnSpacePagesRoute,
                href: (0, $1NBp8.SPACE_PAGES).toUrl({
                    spaceKey: spaceKey
                }),
                ...tooltipProps,
                onClick: sendItemClickedAnalytics('allContent', undefined),
                className: (0, $35pXk.default)([
                    $80aadc0fc178ee11$var$styles.root,
                    isOnSpacePagesRoute && $80aadc0fc178ee11$var$styles.isSelected
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
                id: "side-navigation.container.all-content",
                defaultMessage: "All content"
            })))), links //Depending on the type of space, space settings may be hidden.
        //Make sure space settings is always shown
        .filter((link)=>Boolean(link && (!link.hidden || link.webItemCompleteKey === (0, $28oQf.SPACE_SETTINGS_KEY)))).sort((a, b)=>Number(a.position) - Number(b.position)).map(({ webItemCompleteKey: webItemCompleteKey })=>webItemCompleteKey && builtInItems[webItemCompleteKey] || /* Hide everything else */ null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
            attribution: (0, $dIouf.Attribution).ADMIN_EXPERIENCE
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $feuG2.SpaceSettingsSidebarLinks), {
            isSideNavRefreshAutomationEnabled: links.some(({ webItemCompleteKey: webItemCompleteKey, hidden: hidden })=>webItemCompleteKey === (0, $28oQf.AUTOMATION_KEY) && hidden === false),
            spaceKey: spaceKey,
            isSpaceSettingsScreen: isSpaceSettingsScreen
        })));
    }, [
        getBuiltInItemsMapping,
        links,
        sendItemClickedAnalytics,
        spaceKey,
        isSpaceSettingsScreen,
        isOnSpacePagesRoute
    ]);
    return renderLegacySpaceLinks();
});

});
parcelRegister("27b4e", function(module, exports) {

$parcel$export(module.exports, "DatabasesNavigation", () => $f7a1902cd4b5d988$export$b821f061507a2100);
/* DatabasesNavigation.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $80xJE = parcelRequire("80xJE");

var $5nBzc = parcelRequire("5nBzc");

var $3gadb = parcelRequire("3gadb");

var $2g1PW = parcelRequire("2g1PW");

var $ep3mz = parcelRequire("ep3mz");
const $f7a1902cd4b5d988$var$styles = {
    root: "_2rko1l7b _4bfu1r81 _1hmsagmp _ajmmvv82 _1rjcze3t _bozgu2gc _y4ti1b66 _4t3i14no _1tke14no _1wybdlk8 _bfhk18uv _6ehmu2gc _syaz1gjq _9h8h1gjq _f8pj1gjq _10531gjq _tx28idpf _f1531tcg _o2hc1tcg _vd4ff6fq _10wwf6fq _1l9sf6fq _13lwf6fq _g512f6fq _1iygf6fq _irr3166n",
    isSelected: "_bfhkfg4m _syazaqb7 _9h8haqb7 _f8pjaqb7 _1053aqb7 _irr3i1yw"
};
const $f7a1902cd4b5d988$var$i18n = (0, $2nPZH.defineMessages)({
    databases: {
        id: "side-navigation.databases.word",
        defaultMessage: "Databases"
    },
    alpha: {
        id: "side-navigation.databases.alpha-label",
        defaultMessage: "Alpha"
    },
    tooltip: {
        id: "side-navigation.databases.tooltip",
        defaultMessage: "View all databases in this space"
    }
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f7a1902cd4b5d988$var$CustomItemDiv = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_2rko1l7b _kqswh2mm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f7a1902cd4b5d988$var$LozengeWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1o8l _18u0u2gc",
            __cmplp.className
        ])
    });
});
const $f7a1902cd4b5d988$var$DatabasesNavigationComponent = ({ isSelected: isSelected, onClick: onClick, databasesRoute: databasesRoute })=>{
    const intl = (0, $dBxQj.default)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($f7a1902cd4b5d988$var$CustomItemDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        position: "top",
        content: intl.formatMessage($f7a1902cd4b5d988$var$i18n.tooltip)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $80xJE.default), {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2g1PW))), {
                label: "",
                spacing: "spacious"
            }),
            isSelected: isSelected,
            href: databasesRoute.toUrl({
                spaceKey: spaceKey
            }),
            ...tooltipProps,
            onClick: onClick,
            testId: "space-navigation-databases-link",
            className: (0, $35pXk.default)([
                $f7a1902cd4b5d988$var$styles.root,
                isSelected && $f7a1902cd4b5d988$var$styles.isSelected
            ])
        }, intl.formatMessage($f7a1902cd4b5d988$var$i18n.databases), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($f7a1902cd4b5d988$var$LozengeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5nBzc.default), {
            appearance: "new"
        }, intl.formatMessage($f7a1902cd4b5d988$var$i18n.alpha)))))));
};
const $f7a1902cd4b5d988$export$b821f061507a2100 = /*#__PURE__*/ (0, $gwFzn.memo)($f7a1902cd4b5d988$var$DatabasesNavigationComponent);

});

parcelRegister("lX4Fn", function(module, exports) {

$parcel$export(module.exports, "AnalyticsNavigation", () => $def24d83bdcd6d5a$export$3fb0ce0449690c24);
/* AnalyticsNavigation.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $80xJE = parcelRequire("80xJE");

var $3gadb = parcelRequire("3gadb");

var $5izcQ = parcelRequire("5izcQ");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $ep3mz = parcelRequire("ep3mz");

var $61vzn = parcelRequire("61vzn");

var $jmjWc = parcelRequire("jmjWc");

var $1NBp8 = parcelRequire("1NBp8");

var $oCj79 = parcelRequire("oCj79");

var $dPJCf = parcelRequire("dPJCf");
const $def24d83bdcd6d5a$var$styles = {
    root: "_2rko1l7b _4bfu1r81 _1hmsagmp _ajmmvv82 _1rjcze3t _bozgu2gc _y4ti1b66 _4t3i14no _1tke14no _1wybdlk8 _bfhk18uv _6ehmu2gc _syaz1gjq _9h8h1gjq _f8pj1gjq _10531gjq _tx28idpf _f1531tcg _o2hc1tcg _vd4fgktf _10wwgktf _1l9sgktf _13lwgktf _g512gktf _1iyggktf _irr3166n",
    isSelected: "_bfhkfg4m _syazaqb7 _9h8haqb7 _f8pjaqb7 _1053aqb7 _irr3i1yw"
};
const $def24d83bdcd6d5a$var$listStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.0'
});

const $def24d83bdcd6d5a$export$37c78121e383ea74 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9abwg",
    name: "GraphBarIcon",
    loader: async ()=>(await (parcelRequire("6UIBe"))).GraphBarIcon
});
const $def24d83bdcd6d5a$var$i18n = (0, $2nPZH.defineMessages)({
    analyticsTooltip: {
        id: "side-navigation.space-navigation.analytics.tooltip",
        defaultMessage: "View analytics for this space"
    },
    analytics: {
        id: "side-navigation.container.analytics",
        defaultMessage: "Analytics"
    }
});
const $def24d83bdcd6d5a$export$3fb0ce0449690c24 = ({ onClick: onClick })=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const isSelected = (0, $dPJCf.useRouteName)({
        selector: (routeName)=>routeName === (0, $1NBp8.SPACE_ANALYTICS).name
    });
    const { markFeatureAsUsed: markFeatureAsUsed } = (0, $oCj79.useTrackPremiumFeatureUsage)((0, $oCj79.PremiumFeatureUsage).ANALYTICS_VIEW_SPACE, /* skip */ !isSelected);
    (0, $gwFzn.useEffect)(markFeatureAsUsed, [
        markFeatureAsUsed
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5izcQ.default), {
        key: "space-analytics",
        name: "page-analytics-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        position: "top",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $def24d83bdcd6d5a$var$i18n.analyticsTooltip)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
            as: "li",
            xcss: $def24d83bdcd6d5a$var$listStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $80xJE.default // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        ), {
            key: "analytics",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($def24d83bdcd6d5a$export$37c78121e383ea74, {
                isSelected: isSelected
            }),
            isSelected: isSelected,
            href: (0, $1NBp8.SPACE_ANALYTICS).toUrl({
                spaceKey: spaceKey
            }),
            ...tooltipProps,
            onClick: onClick,
            testId: "space-navigation-analytics-link",
            className: (0, $35pXk.default)([
                $def24d83bdcd6d5a$var$styles.root,
                isSelected && $def24d83bdcd6d5a$var$styles.isSelected
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $def24d83bdcd6d5a$var$i18n.analytics), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $61vzn.PremiumLozengeLoadable), null)))));
};

});
parcelRegister("6UIBe", function(module, exports) {

let $508a918d3b7e82ee$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $508a918d3b7e82ee$var$load("ffEVr"),
    $508a918d3b7e82ee$var$load("9H1r6")
]).then(()=>parcelRequire('cPrVi'));

});


parcelRegister("kfZiO", function(module, exports) {

let $ebf4c2bc5274bca5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $ebf4c2bc5274bca5$var$load("ffEVr"),
    $ebf4c2bc5274bca5$var$load("19Ali")
]).then(()=>parcelRequire('7vo4i'));

});

parcelRegister("77ckH", function(module, exports) {

let $52e2c0e10c74b2ba$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $52e2c0e10c74b2ba$var$load("eabDm"),
    $52e2c0e10c74b2ba$var$load("6dqXI"),
    $52e2c0e10c74b2ba$var$load("ffEVr"),
    $52e2c0e10c74b2ba$var$load("hI11K")
]).then(()=>parcelRequire('9XsDd'));

});

parcelRegister("5IITM", function(module, exports) {

let $42a3e3c69269490e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $42a3e3c69269490e$var$load("fbDZw").then(()=>parcelRequire('2J7a0'));

});

parcelRegister("dcxJa", function(module, exports) {

let $99c68eee0c4938b4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $99c68eee0c4938b4$var$load("7Qxu7").then(()=>parcelRequire('ffPxZ'));

});

parcelRegister("4STYZ", function(module, exports) {

let $38e7a191ef672d1d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $38e7a191ef672d1d$var$load("1vHyq"),
    $38e7a191ef672d1d$var$load("5DqrE")
]).then(()=>parcelRequire('3zytW'));

});


parcelRegister("km9y4", function(module, exports) {

let $ed1d44e10e5b37d4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $ed1d44e10e5b37d4$var$load("1vHyq"),
    $ed1d44e10e5b37d4$var$load("ffEVr"),
    $ed1d44e10e5b37d4$var$load("klGUa")
]).then(()=>parcelRequire('8o2bj'));

});

parcelRegister("7DPsH", function(module, exports) {

let $5904182e3f131609$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $5904182e3f131609$var$load("6vzdH"),
    $5904182e3f131609$var$load("hmhwB"),
    $5904182e3f131609$var$load("i0ovk"),
    $5904182e3f131609$var$load("21dvp"),
    $5904182e3f131609$var$load("ffEVr"),
    $5904182e3f131609$var$load("c6MKV"),
    $5904182e3f131609$var$load("fwbht"),
    $5904182e3f131609$var$load("zogKQ"),
    $5904182e3f131609$var$load("eWlhh")
]).then(()=>parcelRequire('3RRKD'));

});



//# sourceMappingURL=Nav3SpaceNavigationContent.b4632933.js.map
